import React from 'react';
import { Translate } from '@pegasus/translation';
import { SEC_SUB_SUCCESS_PLACEMENT } from '@client/config/constants';
import InfoBox from '@client/components/shared/InfoBox';
import { Button, ButtonType, ButtonColor } from '@lux/buttons';
import { Preset, Text } from '@lux/text';
import * as S from './styles';

import { useStep, MessageProps } from './hooks';

export const SecondarySubscriptionMessage = (props: MessageProps) => {
    const { placement, pending, close } = props;

    const { step } = useStep(props);

    const {
        onAccept,
        onReject = null,
        text,
        title,
        iconComponent,
        yesMessage = 'messageYes',
        noMessage = 'messageNo',
        placeholder = false,
    } = step;

    const isSuccessPage = placement === SEC_SUB_SUCCESS_PLACEMENT;

    return (
        <S.Wrapper>
            <InfoBox
                title={title}
                iconComponent={iconComponent}
                onCloseClick={close}
                noCloseIcon={isSuccessPage}
                inline={isSuccessPage}
                pending={pending || !step}
            >
                {step && (
                    <>
                        <Text preset={Preset.M}>
                            <Translate message={text} html />
                        </Text>
                        {placeholder && <S.ButtonPlaceholder />}
                        <S.ButtonsWrapper>
                            {onAccept && (
                                <Button
                                    type="button"
                                    buttonType={ButtonType.contextual}
                                    onClick={onAccept}
                                    data-testid="accept-button"
                                    style={{ marginRight: '15px' }}
                                >
                                    <Translate message={yesMessage} html />
                                </Button>
                            )}
                            {onReject && (
                                <Button
                                    type="button"
                                    buttonType={ButtonType.contextual}
                                    onClick={onReject}
                                    color={ButtonColor.dark}
                                    data-testid="reject-button"
                                >
                                    <Translate message={noMessage} html />
                                </Button>
                            )}
                        </S.ButtonsWrapper>
                    </>
                )}
            </InfoBox>
        </S.Wrapper>
    );
};

export default SecondarySubscriptionMessage;
